import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { envValue } from '../../../config/envUtils';
import { SAVE_LEVEL } from '../../constants/Level';
import { IN_CONTEXT_BOOKING_STATUS } from '../../constants/InContextBookingStatus';

export class ViewSiteButton extends Component {
    onClickPreviewButton = () => {
        const { chain, code, configCode, hotel, level, isThemeSbem, inContextBookingStatus } = this.props;
        const sbePreviewUrl = envValue('PREVIEW_URL');
        const sbemPreviewUrl = envValue('SBEM_PREVIEW_URL');
        const hotelId = level === SAVE_LEVEL.HOTEL ? hotel : '';
        let url;
        if (isThemeSbem) {
            url = `${sbemPreviewUrl}?&chainId=${chain}&hotelId=${hotelId}&themeCode=${code}&configCode=${configCode}`;
            if (inContextBookingStatus === IN_CONTEXT_BOOKING_STATUS.STAGED) {
                url += `&inContextBookingStatus=${encodeURIComponent(inContextBookingStatus)}`;
            }
        }
        else {
            url = `${sbePreviewUrl}?&chain=${chain}&hotel=${hotelId}&theme=${code}&config=${configCode}&themeCache=false&clearcache=all&notrack=true`;
        }
        window.open(url);
    };

    render() {
        return (
            <button
                className={`spark-btn spark-btn--${this.props.size} spark-btn--secondary`}
                onClick={this.onClickPreviewButton}
                type="button"
            >
                View Site
            </button>
        );
    }
}

ViewSiteButton.propTypes = {
    chain: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    configCode: PropTypes.string.isRequired,
    hotel: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    isThemeSbem: PropTypes.bool.isRequired,
    inContextBookingStatus: PropTypes.string
};

ViewSiteButton.defaultProps = {
    inContextBookingStatus: undefined
};

export const mapStateToProps = state => {
    const configurationState = state.app.data.configuration;
    const configuration = configurationState.configuration || {};
    const currentConfig = configuration.currentConfig || {};
    const currentConfigCopy = configuration.currentConfigCopy || {};
    const configurationStatus = currentConfig.inContextBookingStatus;
    const currentConfigCopyStatus = currentConfigCopy.inContextBookingStatus;

    return {
        chain: state.app.selected.chain.Id,
        code: state.app.selected.code,
        configCode: configuration.configCode,
        hotel: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        isThemeSbem: state.app.selected.isThemeSbem,
        inContextBookingStatus: currentConfigCopyStatus || configurationStatus
    };
};

export default connect(mapStateToProps)(ViewSiteButton);



// WEBPACK FOOTER //
// ./src/components/common/ViewSiteButton.js